"use strict";
/**
 * Transliteration schema registry.
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Schemas = void 0;
var schema_1 = require("./schema");
var _definitions_1 = require("./generated/_definitions");
/**
 * All supported transliteration schemas.
 */
var Schemas = /** @class */ (function () {
    function Schemas() {
    }
    Object.defineProperty(Schemas, "all", {
        /**
         * Lazy-loaded schema map.
         */
        get: function () {
            if (!this._all) {
                this._all = loadSchemas();
            }
            return this._all;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Array of schema names.
     */
    Schemas.names = function () {
        return Array.from(this.all.keys()).sort();
    };
    /**
     * Array of schemas.
     */
    Schemas.values = function () {
        return Array.from(this.all.values());
    };
    /**
     * Get schema by name.
     */
    Schemas.get = function (name) {
        var schema = this.all.get(name);
        if (!schema) {
            throw new Error("No such schema: " + name);
        }
        return schema;
    };
    return Schemas;
}());
exports.Schemas = Schemas;
function loadSchemas() {
    var e_1, _a;
    var map = new Map();
    try {
        for (var DEFINITIONS_1 = __values(_definitions_1.default), DEFINITIONS_1_1 = DEFINITIONS_1.next(); !DEFINITIONS_1_1.done; DEFINITIONS_1_1 = DEFINITIONS_1.next()) {
            var defn = DEFINITIONS_1_1.value;
            var schema = schema_1.Schema.load(defn);
            map.set(schema.name, schema);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (DEFINITIONS_1_1 && !DEFINITIONS_1_1.done && (_a = DEFINITIONS_1.return)) _a.call(DEFINITIONS_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return map;
}
